import React from 'react';

const CouponCutEffectIconRight = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={5}
      height={40}
      viewBox='0 0 5 40'
      fill='none'
      {...props}
    >
      <path
        d='M4.76837e-07 5L5 4.76837e-07L6.95394e-07 2.5828e-07L4.76837e-07 5Z'
        fill='#450B05'
      />
      <path d='M5 10L4.37114e-07 5L0 15L5 10Z' fill='#450B05' />
      <path d='M5 20L4.37114e-07 15L0 25L5 20Z' fill='#450B05' />
      <path d='M5 30L4.37114e-07 25L0 35L5 30Z' fill='#450B05' />
      <path d='M5 40L4.37114e-07 35L0 45L5 40Z' fill='#450B05' />
    </svg>
  );
};

export default CouponCutEffectIconRight;
